import axios from "axios";
import { GET_RECENT_OFFERS, REDEEM_OFFER } from "../../Store/Type";
import { toast } from "react-toastify";
const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});
const apiUrl = process.env.REACT_APP_API_URL;
const user = sessionStorage.getItem("USER_ID");

export const GetRedeemOffersData = async (dispatch, filter) => {
  try {
    // const response = await axios.get(`${apiUrl}/redeem-offers-deals`);
    const response = await api.get(
      `${apiUrl}/request-offerStatus/${user}/${
        filter == "all"
          ? 5
          : filter == "pending"
          ? 1
          : filter == "posted"
          ? 1
          : filter == "approved"
          ? 2
          : filter == "active"
          ? 2
          : filter == "hold"
          ? 3
          : filter == "rejected"
          ? 4
          : filter == "draft"
          ? 0
          : 5
      }`
    );
    dispatch({ type: REDEEM_OFFER, payload: response.data });
    console.log(response.data, "offers_status_filter");
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const SubmitRedeemExcel = async (file,setExcelData) => {
  const formData = new FormData();
  formData.append("xlsxFile", file);
  formData.append("tbs_user_id", sessionStorage.getItem("USER_ID"));
  const excelEndpoint = `${apiUrl}/redeem-offers-deals-importExcel`;
  const method = "post";
  try {
    const response = await api({
      url: excelEndpoint,
      method: method,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Offers_Response", response);

      if(response.data.inserted > 0){ 
      console.log("Offers_Response",response.data.inserted);
    toast.success("Inserted Successfully");
    }else{
      console.log("Offers_Response",response.data.inserted);
      toast.warning("Redeem already exist");
    }

    // if (response.status >= 200 && response.status < 300) {
    //   if (
    //     typeof response.data === "string" &&
    //     response.data.includes("Error")
    //   ) {
    //     toast.error(response.data);
    //   } else {
    //     toast.success(response.data);
    //   }
    // }
    

    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    toast.error("Failed to upload file");
    return null;
  }finally{
setExcelData();
  }
};

export const SubmitRedeemOffersData = async (
  dispatch,
  promotionvalues,
  updatedata,
  offerlist,
  offerBackGround,
  offerFilter,
  noValToStatus
) => {
  console.log(promotionvalues, "promotionvalues");
  const formData = new FormData();
  formData.append(
    "offer_name",
    promotionvalues.offer_name ? promotionvalues.offer_name : null
  );
  formData.append("code", promotionvalues.code ? promotionvalues?.code?.toUpperCase() : null);
  formData.append(
    "start_date",
    promotionvalues.start_date ? promotionvalues.start_date : new Date()
  );
  formData.append(
    "expiry_date",
    promotionvalues.expiry_date ? promotionvalues.expiry_date : new Date()
  );
  formData.append("usage", offerlist.usage ? offerlist.usage : null);
  // formData.append("image_id",offerlist.image_id?offerlist.image_id:null);
  formData.append("image_id",offerlist.image_id === null ? 1 : offerlist.image_id);

  if(noValToStatus===false) {

  formData.append(
    "status",
    promotionvalues.status ? promotionvalues.status : null
  );

  formData.append(
    "status_id",
    promotionvalues.status == "Draft"
      ? 0
      : promotionvalues.status == "Active"
      ? 2
      : promotionvalues.status == "Posted"
      ? 1
      : ""
  );
  formData.append(
    "req_status",
    promotionvalues.status == "Draft"
      ? "Draft"
      : promotionvalues.status == "Posted"
      ? "Pending"
      : "Active"
  );
  formData.append(
    "req_status_id",
    promotionvalues.status == "Draft"
      ? 0
      : promotionvalues.status == "Posted"
      ? 6
      : 2
  );
  formData.append("tbs_user_id", sessionStorage.getItem("USER_ID"));
}

  formData.append(
    "offer_desc",
    promotionvalues.offer_desc ? promotionvalues.offer_desc : null
  );
  formData.append(
    "offer_img",
    promotionvalues.file ? promotionvalues.file : null
  );
  formData.append("occupation_id", promotionvalues?.occupation);
  formData.append(
    "occupation",
    promotionvalues?.occupation == 1
      ? "Business"
      : promotionvalues?.occupation == 2
      ? "General Public"
      : promotionvalues?.occupation == 3
      ? "Handicapped"
      : promotionvalues?.occupation == 4
      ? "Pilgrim"
      : promotionvalues?.occupation == 5
      ? "Senior Citizen"
      : promotionvalues?.occupation == 6
      ? "Student"
      : promotionvalues?.occupation == 7
      ? "Tourist"
      : promotionvalues?.occupation == 8
      ? "All"
      : ""
  );
  formData.append("theme", offerBackGround);


  console.log(updatedata, "ADD_UPDATE_OFFERS_DATA");
  const url = updatedata
    ? `${apiUrl}/redeem-offers-deals/${updatedata}`
    : `${apiUrl}/redeem-offers-deals`;
  const method = updatedata ? "put" : "post";

  try {
    const response = await api({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    GetRedeemOffersData(dispatch, offerFilter);
    console.log(offerFilter, "offers_filter_api");
    console.log(response, "responseresponse");
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const ChangeRedeemStatus = async (
  id,
  currentid,
  dispatch,
  filterid,
  cmnt
) => {
  const payload = {
    req_status:
      id === 2 ? "Approved" : id === 3 ? "Hold" : id === 4 ? "Rejected" : "",
    req_status_id: id,
    status:
      id === 2 ? "Active" : id === 3 ? "Hold" : id === 4 ? "Rejected" : "",
    status_id: id,
    comments:id === 2 ? null : cmnt,
  };

  const url = `${apiUrl}/request-management-offer/${currentid}`;
  const method = "put";
  console.log(payload, "commentresponse");
  try {
    const response = await api({
      method,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });
    toast.success("Status Updated");
    GetRedeemOffersData(dispatch, filterid);
    
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SearchRedeemOffer = async (e, filter, dispatch) => {
  const SearchID =
    filter == "all"
      ? 5
      : filter == "pending"
      ? 1
      : filter == "posted"
      ? 1
      : filter == "approved"
      ? 2
      : filter == "active"
      ? 2
      : filter == "hold"
      ? 3
      : filter == "rejected"
      ? 4
      : filter == "draft"
      ? 0
      : 5;
  try {
    if (e) {
      const response = await axios.post(
        `${apiUrl}/request-management-offerSearch`,
        {
          req_status_id: SearchID,
          search_term: e,
        }
      );

      dispatch({ type: REDEEM_OFFER, payload: response.data });
    } else {
      GetRedeemOffersData(dispatch, filter);
    }
  } catch (err) {
    handleError(err);
  }
};

export const GetRedeemOffersById = async (
  updatedata,
  SetUpdateData,
  setOfferData,
  setLoading
) => {
  console.log(updatedata, "ahsgxdahsjksaxbj");
  try {
    const response = await api.get(
      `${apiUrl}/redeem-offers-deals/${updatedata}`
    );
    console.log(response, "responseresponse");
    setOfferData("");
    return response?.data[0];
  } catch (error) {
    handleError(error);
    return null;
  } finally {
    setLoading(false);
  }
};

export const handleRedeemoffersearch = async (e, dispatch) => {
  try {
    if (e.target.value) {
      const response = await api.get(
        `${apiUrl}/redeem-offers-deals-search/${e.target.value}`
      );
      dispatch({ type: REDEEM_OFFER, payload: response.data });
      return response.data[0];
    } else {
      GetRedeemOffersData(dispatch);
    }
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const GetRedeemRecentOffers = async (dispatch) => {
  try {
    const response = await axios.get(`${apiUrl}/redeem-recentOffers`);
    dispatch({ type: GET_RECENT_OFFERS, payload: response.data });
    console.log(response, "response from recent offers");

    return response.data;
  } catch (error) {
    handleError(error);
  }
};
const handleError = (error) => {
  console.error("Error details:", error);
  let errorMessage = "An error occurred";

  if (error.response) {
    console.error("Error response from server:", error.response);
    errorMessage = `Server responded with status ${error.response.status}`;
  } else if (error.request) {
    console.error("No response received:", error.request);
    errorMessage = "No response received from server";
  } else {
    console.error("Error setting up request:", error.message);
    errorMessage = error.message;
  }

  if (error.code === "ERR_NETWORK") {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }
  if (error.code === "ERR_CONNECTION_REFUSED") {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }
  toast.error(errorMessage);
};
